
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import type { Connector } from 'react-redux'
import type { Store } from 'types/index'
import coinsExtended from 'selectors/coinsExtended'
import {logOut} from '../../../actions/auth';
import {setSelectedCoin} from '../../../actions/ui/index';
import {openModal} from '../../../actions/ui/modals';
import {CoinsList} from '../../coinslist/index';
import LoadingBar from '../../../components/loadingBar'
// import Topbar from './topbar'
import _ from 'lodash'
//import { generateGuid } from 'helpers/index';
//import { db } from 'actions/firebaseInit'
//import DataFetcher from './dataFetcher'

import ChartView from './chartView'

import './styles.css'

class Main extends PureComponent {
  constructor(props){
    super(props)

    // hacky way to open the login modal on typing 'magma'
    this.ghostString  =''
  }

  arrorPressed = (direction) => {
    const { coins, selectedCoin } = this.props

    if(!selectedCoin) return this.selectCoin(coins[0].id)

    const selectedCoinIndex = _.findIndex(coins, (c) => c.id === selectedCoin)

    const coinUnder = coins[selectedCoinIndex + 1]
    const coinAbove = coins[selectedCoinIndex - 1]

    if(direction === 'down') coinUnder && this.selectCoin(coinUnder.id)
    if(direction === 'up')   coinAbove && this.selectCoin(coinAbove.id)
  }

  componentDidMount = () => {
    window.addEventListener('keyup', (e) => {
      if(e.keyCode === 38) this.arrorPressed('up')
      if(e.keyCode === 40) this.arrorPressed('down')
      this.ghostString += e.key
      if(this.ghostString.includes('logmein')) {this.props.openLoginModal(); this.ghostString = ''}
      if(this.ghostString.includes('logmeout')) {logOut(); this.ghostString = ''}
    })

    // const { coinID } = this.props.match.params
    // coinID && this.props.setSelectedCoin(coinID)
  }

  selectCoin = (id) => {
    this.props.setSelectedCoin(id)
    this.props.history.push('/app/main/' + id)
  }

  render(){
    const { coins, selectedCoin, adminMode } = this.props

    return (
      <fb className="app-main-main">
        <fb className="coin-list-wrapper">
          <CoinsList
            coins={coins}
            selectedCoin={selectedCoin}
            selectCoin={this.selectCoin}
            editCoin={this.props.editCoin}
            adminMode={this.props.adminMode}
          />
        </fb>
        <fb className="mainRight">
          {/* <Topbar /> */}
          { (!coins.length)
              ? <LoadingBar />
              : <ChartView adminMode={adminMode} />
          }
        </fb>
      </fb>
    )
  }
}

const actionsToProps = {
  editCoin: (editID) => openModal('EDIT_COIN', { coinID: editID }),
  openLoginModal: () => openModal('LOGIN_MODAL'),
  setSelectedCoin,
}

const mapStateToProps = (state: Store) => ({
  coins: coinsExtended(state),
  selectedCoin: state.ui.selectedCoin,
  adminMode: state.auth.adminMode,
  user: state.user,
  userLoaded: state.userDataStatus === 'LOADED'
})

const connector: Connector<{}, Props> = connect(mapStateToProps, actionsToProps)
export default connector(Main)



// WEBPACK FOOTER //
// ./src/containers/app/main/index.js